import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAxiosInstances } from '../../../infra/axios-instance';
import { useAuthService } from '../../../use-cases/auth';
import { useAppDispatch } from '../../hooks/store-hooks';
import { setToken } from '../../../application/states/auth';

import { PreLoader } from '../../loading-container/pre-loader';

export const AuthSyncPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { axiosInstance } = useAxiosInstances();
    const { insertAcesso } = useAuthService();
    // O código é de uso único: impede a 2ª execução do effect (StrictMode/re-render)
    const exchangedRef = useRef(false);

    useEffect(() => {
        if (exchangedRef.current) return;
        exchangedRef.current = true;

        const sync = async () => {
            const queryParams = new URLSearchParams(location.search);
            const code = queryParams.get('code');
            const legacyToken = queryParams.get('token');
            const loginUrl = (process.env.REACT_APP_VELES_MODULES_URL!);

            let initialToken: string | null = null;

            // Fluxo legado: token direto na URL
            if (!code && legacyToken) {
                initialToken = legacyToken;
            } else if (code) {
                try {
                    // O token é trocado por POST com body (nunca trafega na URL)
                    const response = await axiosInstance.post('/auth/sync/exchange', { code });
                    initialToken = response.data?.result?.token;
                } catch {
                    window.location.replace(loginUrl);
                    return;
                }
            } else {
                window.location.replace(loginUrl);
                return;
            }

            if (!initialToken) {
                window.location.replace(loginUrl);
                return;
            }

            try {
                localStorage.setItem('ACCESS_TOKEN', initialToken);
                dispatch(setToken({ token: initialToken }));

                // Registra o acesso ao sistema (IdProduto 14 = Dossiê) e obtém o token com IdAcesso
                await insertAcesso(14);

                navigate('/private/dossie/search', { replace: true });
            } catch (error) {
                console.error('Erro ao registrar acesso:', error);
                window.location.replace(loginUrl);
            }
        };

        sync();
    }, [location, navigate, axiosInstance, insertAcesso, dispatch]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f2eef8' }}>
            <PreLoader />
        </div>
    );
};
